module.exports = __webpack_public_path__ + "assets/images/ample-logo-audio.fa583ba5.png";